// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"d0-z"};